import { useState } from "react";
import { Link } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { useLang } from "@/i18n";
import { DEALER_RANGE_START, DEALER_RANGE_END, getDealerSession, setDealerSession } from "@/utils/dealerSession";

export default function RequireDealer({ children }) {
    const { t } = useLang();
    const [session, setSession] = useState(() => getDealerSession());
    const [kdn, setKdn] = useState("");
    const [error, setError] = useState("");

    if (session) return children;

    const submit = (e) => {
        e.preventDefault();
        const cleaned = kdn.replace(/\D/g, "");
        const num = parseInt(cleaned, 10);
        if (!(DEALER_RANGE_START <= num && num <= DEALER_RANGE_END)) {
            setError(t("Diese Kundennummer hat keinen Zugang. Bitte wenden Sie sich an vertrieb@satmueller.de", "This customer number has no access. Please contact vertrieb@satmueller.de"));
            return;
        }
        setSession(setDealerSession(num));
        setError("");
    };

    return (
        <main className="pt-28 sm:pt-32 pb-20 sm:pb-24">
            <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-12">
                <Reveal>
                    <div className="rounded-2xl bg-white border border-slate-200 shadow-sm p-8" data-testid="shop-login-gate">
                        <Eyebrow>{t("Händler-Login", "Dealer login")}</Eyebrow>
                        <h1 className="mt-4 font-display text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">
                            {t("Bitte im Händlerbereich anmelden.", "Please sign in to the dealer area.")}
                        </h1>
                        <p className="mt-3 text-sm text-slate-600 leading-relaxed">
                            {t(
                                "Der Bestellshop ist Fachhändlern vorbehalten. Geben Sie Ihre Kundennummer ein — kein Passwort nötig.",
                                "The ordering shop is reserved for trade dealers. Enter your customer number — no password needed."
                            )}
                        </p>
                        <form onSubmit={submit} className="mt-6 flex flex-col sm:flex-row gap-3" data-testid="shop-login-form">
                            <input
                                type="text"
                                inputMode="numeric"
                                value={kdn}
                                onChange={(e) => setKdn(e.target.value)}
                                placeholder={t("Kundennummer (z. B. 10001001)", "Customer number (e.g. 10001001)")}
                                data-testid="shop-login-kdn-input"
                                className="flex-1 rounded-full border border-slate-300 bg-white px-5 py-3 text-sm text-slate-900 placeholder:text-slate-400 focus:border-red-500 focus:outline-none"
                            />
                            <button
                                type="submit"
                                data-testid="shop-login-submit"
                                className="inline-flex items-center justify-center gap-2 rounded-full bg-red-700 hover:bg-red-800 text-white font-semibold text-sm px-7 py-3 transition-colors"
                            >
                                <KeyRound className="h-4 w-4" />
                                {t("Anmelden", "Sign in")}
                            </button>
                        </form>
                        {error && (
                            <p className="mt-3 text-sm font-semibold text-red-700" data-testid="shop-login-error">
                                {error}
                            </p>
                        )}
                        <p className="mt-6 text-sm text-slate-500">
                            {t("Noch kein Zugang?", "No access yet?")}{" "}
                            <a href="mailto:vertrieb@satmueller.de?subject=Freischaltung%20H%C3%A4ndlershop" className="font-semibold text-red-700 hover:text-red-800">
                                vertrieb@satmueller.de
                            </a>
                        </p>
                    </div>
                </Reveal>
            </div>
        </main>
    );
}
